import React from "react";
import { Link } from "react-router-dom";
import { RiLayoutFill } from "react-icons/ri";
import { MdMovieFilter } from "react-icons/md";
import { IoMdTrendingUp } from "react-icons/io";
import { MdBookmark } from "react-icons/md";
import { IoMdSearch } from "react-icons/io";
import "./Sidebar.scss";

const Sidebar = ({ isOpen, toggleSidebar }) => {
  return (
    <div className={isOpen ? "sidebar active" : "sidebar"}>
      <ul className="sidebar-links">
        <li className="sidebar-item" onClick={toggleSidebar}>
          <Link to="/" className="sidebar-link">
            Home
            <RiLayoutFill className="sidebar-link-icon" />
          </Link>
        </li>
        <li className="sidebar-item" onClick={toggleSidebar}>
          <Link to="/new-movies" className="sidebar-link">
            New Movies
            <MdMovieFilter className="sidebar-link-icon" />
          </Link>
        </li>
        <li className="sidebar-item" onClick={toggleSidebar}>
          <Link to="/trending-movies" className="sidebar-link">
            Trending
            <IoMdTrendingUp className="sidebar-link-icon" />
          </Link>
        </li>
        <li className="sidebar-item" onClick={toggleSidebar}>
          <Link to="/watchlist" className="sidebar-link">
            Watchlist
            <MdBookmark className="sidebar-link-icon" />
          </Link>
        </li>
        <li className="sidebar-item" onClick={toggleSidebar}>
          <Link to="/search" className="sidebar-link">
            Search
            <IoMdSearch className="sidebar-link-icon" />
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
